import { render } from "./BusinessClients.vue?vue&type=template&id=0de93d50&scoped=true"
import script from "./BusinessClients.vue?vue&type=script&lang=js"
export * from "./BusinessClients.vue?vue&type=script&lang=js"

import "./BusinessClients.vue?vue&type=style&index=0&id=0de93d50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de93d50"]])

export default __exports__